import React, { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import PageContainer from "~/components/PageContainer";
import { getData } from "~/functions/gridFunctions";
import { FullGridContext } from "../..";
import PagePreview from "./Preview";

export default function Department() {
  const filial = useSelector((state) => state.auth.filial);
  const defaultOrderBy = { column: "name", asc: true };
  const defaultGridHeader = [
    {
      title: "Name",
      name: "name",
      type: "text",
      filter: true,
    },
    {
      title: "Filial",
      name: "filial",
      type: "text",
      filter: true,
    },
  ];

  const {
    accessModule,
    setActiveFilters,
    limit,
    opened,
    orderBy,
    page,
    search,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLoadingData,
    setPages,
  } = useContext(FullGridContext);

  const pageAccess = accessModule.children.find(
    (el) => el.alias === "hr-department"
  );

  useEffect(() => {
    setActiveFilters([]);
  }, []);

  useEffect(() => {
    setGridHeader(defaultGridHeader);
  }, []);

  async function loader() {
    setLoadingData(true);
    const data = await getData("departments", {
      limit,
      page,
      orderBy,
      setPages,
      setGridData,
      search,
      defaultGridHeader,
      defaultOrderBy,
      setGridDetails,
    });

    if (!data) {
      setGridData([]);
      setLoadingData(false);
      return;
    }

    const gridDataValues = data.map(
      ({ id, name, filial: departmentFilial, canceled_at }, index) => {
        const filialName = departmentFilial?.name || "";
        return {
          show: true,
          id,
          fields: [name, filialName],
          canceled: canceled_at,
          page: Math.ceil((index + 1) / limit),
        };
      }
    );
    setGridData(gridDataValues);
    setLoadingData(false);
  }

  useEffect(() => {
    loader();
  }, [opened, filial, orderBy, search, limit, page]);

  return (
    <PageContainer
      FullGridContext={FullGridContext}
      PagePreview={PagePreview}
      pageAccess={pageAccess}
      defaultGridHeader={defaultGridHeader}
    />
  );
}
